import { i18n } from '@apps/main/modules/localization/localizationSetup';

import { money } from '@libs/utils';
import type { AppSimpleTableRow } from '@libs/ui';
import type {
  CancellationPolicy,
  TaxesAndFee,
} from '@libs/trip-planner-interfaces';
import { SemboDate, DateFormat } from '@libs/sembo-dates';

import type { PriceBreakdown } from './models';

const { t } = i18n.global;

// TODO: test & split into smaller functions?
export function getPriceBreakdownRows(
  priceBreakdown: PriceBreakdown
): AppSimpleTableRow[] {
  const rows: AppSimpleTableRow[] = [];

  if (priceBreakdown.priceExcludingTaxes) {
    const row = {
      leftSide: t('planner.price_excluding_taxes_and_fees'),
      rightSide: money(priceBreakdown.priceExcludingTaxes),
    };
    rows.push(row);
  }

  priceBreakdown.taxesAndFees.forEach((tax: TaxesAndFee) => {
    const taxType = t(`taxes_and_fees.${tax.type}`);
    const taxIncluded = tax.isIncludedInPrice
      ? t('planner.included')
      : t('planner.not_included');
    const leftSide = `${taxType} (${taxIncluded})`;

    const signStr = tax.isIncludedInPrice ? '' : '+ ';
    const moneyStr = money(tax.amount);
    const rightSide = `${signStr}${moneyStr}`;

    const row = { leftSide, rightSide };
    rows.push(row);
  });

  const totalPayRow = {
    leftSide: t('planner.total_to_pay'),
    rightSide: money(priceBreakdown.totalPrice),
  };

  rows.push(totalPayRow);

  if (
    priceBreakdown.priceAtLocation &&
    priceBreakdown.priceAtLocation.amount > 0
  ) {
    const payThereRow = {
      leftSide: t('planner.pay_there'),
      rightSide: money(priceBreakdown.priceAtLocation),
    };
    rows.push(payThereRow);
  }

  return rows;
}

// TODO: test
export function getCancellationPoliciesRows(
  cancellationPolicies: CancellationPolicy[]
): AppSimpleTableRow[] {
  return cancellationPolicies.map((cancellationPolicy: CancellationPolicy) => {
    const text = t('planner.cancel_after');
    const date = formatDate(cancellationPolicy.fromDate);
    const leftSide = `${text} ${date}`;
    const rightSide = money(cancellationPolicy.amount);

    return {
      leftSide,
      rightSide,
    };
  });
}

function formatDate(date: string): string {
  return new SemboDate(date).format(DateFormat.FullDateTime);
}
